export default __webpack_public_path__ + "static/media/illustration-success.2efdeeb5.svg";